import { Controller, useFormContext } from "react-hook-form";
import { type TextAreaProps } from "antd/es/input";
import { AppTextArea } from "@/shared/Components/Inputs";
import type { FC } from "react";
import { FormFieldWrapper } from "../../FormFieldWrapper";

export const FormTextArea: FC<TextAreaProps & { customOnChange?: () => void }> = ({
  name = "",
  customOnChange,
  ...props
}) => {
  const { control } = useFormContext();
  return (
    <FormFieldWrapper name={name}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value, ref } }) => (
          <AppTextArea
            ref={ref}
            value={value}
            onChange={(e) => {
              onChange(e);
              customOnChange?.();
            }}
            {...props}
          />
        )}
      />
    </FormFieldWrapper>
  );
};
